$("a.video").each(function () {
    const video = $(this);
    const thisInner = video.html();

    // Set attributes
    const classAttributes = video.attr('class') ? `class="${video.attr('class')}"` : '';
    const dataVideoSrcAttributes = video.data('video-src') ? `data-video-src="${video.data('video-src')}"` : '';
    const dataBsToggleAttributes = video.attr('data-bs-toggle') ? `data-bs-toggle="${video.attr('data-bs-toggle')}"` : '';
    const dataBsTargetAttributes = video.attr('data-bs-target') ? `data-bs-target="${video.attr('data-bs-target')}"` : '';
    const dataMfpSrcAttributes = video.data('mfp-src') ? `data-mfp-src="${video.data('mfp-src')}"` : '';
    // Apply attributes
    const buttonAttributes = [
        classAttributes,
        dataVideoSrcAttributes,
        dataBsToggleAttributes,
        dataBsTargetAttributes,
        dataMfpSrcAttributes
    ].filter(Boolean).join(' ');

    // Construct and replace with button
    video.replaceWith('<button type="button" '+buttonAttributes+'>'+thisInner+'</button>');
});
